import {
	SentimentDissatisfiedOutlined,
	SentimentNeutralOutlined,
	SentimentSatisfiedOutlined,
	SentimentVeryDissatisfiedOutlined,
	SentimentVerySatisfiedOutlined,
} from '@mui/icons-material';
import { FC } from 'react';

const ICON_SIZE = {
	width: '24px',
	height: '24px',
};

export const SatisfactionRateIcon: FC<{ readonly rate: number }> = ({ rate }) => {
	if (rate < 20) {
		return <SentimentVeryDissatisfiedOutlined sx={{ color: (theme) => theme.palette.dustred[300], ...ICON_SIZE }} />;
	}
	if (rate >= 20 && rate < 40) {
		return (
			<SentimentDissatisfiedOutlined
				sx={{
					color: (theme) => theme.palette.orange[300],
					...ICON_SIZE,
				}}
			/>
		);
	}
	if (rate >= 40 && rate < 60) {
		return <SentimentNeutralOutlined sx={{ color: (theme) => theme.palette.grey[500], ...ICON_SIZE }} />;
	}
	if (rate >= 60 && rate < 80) {
		return (
			<SentimentSatisfiedOutlined
				sx={{
					color: (theme) => theme.palette.green[300],
					...ICON_SIZE,
				}}
			/>
		);
	}
	if (rate >= 80) {
		return (
			<SentimentVerySatisfiedOutlined
				sx={{
					color: (theme) => theme.palette.green[500],
					...ICON_SIZE,
				}}
			/>
		);
	}
	return null;
};
